import React, {useEffect, useState} from 'react';
import { useRouter } from 'next/router';
import {useDispatch, useSelector} from 'react-redux';
import axios from 'axios';
import dynamic from 'next/dynamic';
import ConsoHead from '../../components/header/ConsoHead';
import ConsoNavbar from '../../components/header/Navbar';
import LeadFlow from '../../components/lead/LeadFlow';
import { leadMenuList } from '../../components/header/mainMenuList';
const ConsoFooter = dynamic(() => import('../../components/footer/ConsoSmallFooter'));
import {loadCartFromStorage} from '../../components/utils/general/cartUtils';
import { saveProducts } from '../../components/cart/cartSlice';

const LeadPage = (props) => {
    const {provider, formFields, defaultFormData} = props;
    const router = useRouter();
    const {type, amount, term, currency, financer} = router.query;
    const dispatch = useDispatch();
    const shoppingCart = useSelector( state => state.cart);
    const cart = shoppingCart.products;

    useEffect(
        ()=>{
            setupCart();
        }, []
    )

    const seo  = {
        title: `Credite Online ${provider}`,
        description: `Credite Online ${provider}: Aplică online la un credit și vei fi contactat telefonic de către ${provider} pentru a obține împrumutul dorit`,
        canonical: `${process.env.NEXT_PUBLIC_SITE_URL}/intermediere/${provider.toLowerCase().replace( / /g, '-')}`
    };

    const setupCart = () => {
        if (cart && cart.length == 0) {
            const storageData = loadCartFromStorage();
            if (storageData && storageData.products) { 
                dispatch(saveProducts({ products: storageData.products, status: 'init'}));
            }
        }
    }

    return (
        <>
            <ConsoHead seo={seo}  />
            <ConsoNavbar menu={leadMenuList} cart={cart} />
            <div className="mb-0 pb-0" id="main" >  
                <LeadFlow
                    fields={formFields}
                    provider={provider}
                    defaultLoanType={type}
                    defaultTerm={term}
                    defaultAmount={amount}
                    defaultCurrency={currency}
                    defaultBank={financer}
                    defaultFormData={defaultFormData}
                />
            </div>
            <ConsoFooter />
        </>
    );
}

export default LeadPage;

export async function getServerSideProps({params, query}) {
    let bankSlug = params.bank;
    let notFound = false;
    let fields, provider;
   
    if (bankSlug.length==1) {
        try {   
            let url = process.env.NEXT_PUBLIC_ENDAPI + `/api/lead/form/fields`;
            const response = await axios({
                url, 
                method: 'get',
                params:{
                    provider: bankSlug[0],
                    product: 'loan',
                },
                headers: {'Content-Type': 'application/json'},
            });
            let data = response.data; 
            if (data.status) {
                fields = data.fields;
                provider = data.provider.name;
            } else {
                notFound = true;
            }
        } catch(err) {
          
            notFound = true;
        }

    } else {
        notFound = true;
    }
    
    if (notFound) {
        return {
            notFound: true,
        }
    }

    let defaultFormData = false;

    if (query.hasOwnProperty('track')) {
        try{
            const response  = await axios({
                url: process.env.NEXT_PUBLIC_ENDAPI + `/api/lead/track/${query.track}`,
                method: 'get',
                headers: {'Content-Type': 'application/json'},
            });
            let data = response.data; 
            if (data.status) {
                defaultFormData = data.data;
            }
        } catch (err) {
            
        }
    }
    

    return {
        props: {
            formFields: fields,
            provider,
            defaultFormData
        }
    }

}